import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import PulsoidClient from '../PulsoidClient';
import {BounceLoader} from 'react-spinners';

const descriptions = {};

// TODO: Consider refactoring this component into 2 instead of having `controlled` prop
export class FeatureDescriptionModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      loaded: false,
      content: '',
      title: 'Loading...',
    };
  }

  loadContent = () => {
    if (descriptions[this.props.id] && descriptions[this.props.id]) {
      descriptions[this.props.id].then((res) =>
        this.setState({
          loaded: true,
          content: res.content,
          title: res.title,
        })
      );
    } else {
      let promise = new PulsoidClient({publicRpc: true}).getFeatureDescription(
        this.props.id
      );
      descriptions[this.props.id] = promise;
      promise.then(
        (res) =>
          this.setState({
            loaded: true,
            content: res.content,
            title: res.title,
          }),
        () => (descriptions[this.props.id] = undefined)
      );
    }
  };

  componentDidMount() {
    this.loadContent();
  }

  render() {
    let modalContent = this.state.content;
    const showModal = this.props.controlled
      ? this.props.isOpen
      : this.state.show;

    if (showModal && !this.state.loaded) {
      modalContent = <BounceLoader />;
    }

    let children;
    if (!this.props.controlled) {
      if (this.props.component) {
        children = this.props.component(() => {
          if (!this.props.show) {
            new PulsoidClient({publicRpc: true}).reportFeatureDescriptionOpened(
              this.props.id
            );
          }
          this.setState({show: !this.state.show});
        });
      } else {
        let text = '\u24D8';
        if (this.props.text) {
          text = this.props.text;
        }
        children = (
          <a
            href={'#'}
            style={{
              color: this.props.iconColor ? this.props.iconColor : '#11A2B1',
            }}
            onClick={() =>
              this.setState({show: true}, () =>
                new PulsoidClient({
                  publicRpc: true,
                }).reportFeatureDescriptionOpened(this.props.id)
              )
            }
          >
            {text}
          </a>
        );
      }
    }

    // eslint-disable-next-line
    return (
      <>
        {children}
        <Modal
          size="lg"
          show={showModal}
          onHide={() =>
            this.props.controlled
              ? this.props.onClose()
              : this.setState({show: false})
          }
        >
          <Modal.Header closeButton>
            <h2>{this.state.title}</h2>
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{__html: modalContent}}></div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export const ResolveWidgetLinkFeatureDescription = ({predefinedWidgetId}) => {
  switch (predefinedWidgetId) {
    case '66d59add-83aa-4ad0-9cba-380456431f4b': // overlay
      return (
        <FeatureDescriptionModal id={'2256e860-355a-4b67-b088-4df062b4bcd1'} />
      );
    case '2f75277c-188b-463e-b8bd-7b63f926eb58': // overlay
      return (
        <FeatureDescriptionModal id={'2256e860-355a-4b67-b088-4df062b4bcd1'} />
      );
    default:
      return (
        <FeatureDescriptionModal id={'4cb57d68-6161-4ee6-b8db-257e86ba7527'} />
      );
  }
};

export const ResolvePredefinedWidgetFeatureDescription = ({
  predefinedWidgetId,
}) => {
  switch (predefinedWidgetId) {
    case '66d59add-83aa-4ad0-9cba-380456431f4b':
      return (
        <FeatureDescriptionModal id={'26882e66-4f87-4e3e-abb9-640acaa9603c'} />
      );
    case '2f75277c-188b-463e-b8bd-7b63f926eb58':
      return (
        <FeatureDescriptionModal id={'26882e66-4f87-4e3e-abb9-640acaa9603c'} />
      );
    case '103b5e5b-bce8-41b5-999f-0a4fcaa0b393':
      return (
        <FeatureDescriptionModal id={'e485216c-d231-4cbd-b05f-59c56d420a88'} />
      );
    case '4191317d-07ee-4357-aba3-47e2190e5885':
      return (
        <FeatureDescriptionModal id={'d1fd45c3-2fb6-4e48-8725-60342ddeaf13'} />
      );
    default:
      return <></>;
  }
};

export const PremiumFeatureDescription = () => (
  <FeatureDescriptionModal id={'d8d3a402-3b67-4fa0-ac7d-e7586954ee53'} />
);

export const PremiumWrapperFeatureDescription = () => (
  <FeatureDescriptionModal id={'d8d3a402-3b67-4fa0-ac7d-e7586954ee53'} />
);
export const ReferralFeatureDescription = () => (
  <FeatureDescriptionModal id={'7bd0c297-52fd-4246-8c67-4ae0b63135fa'} />
);
export const DiscordIntegrationFeatureDescription = () => (
  <FeatureDescriptionModal id={'f3051d5e-0779-49eb-a6b3-ed83c7fe172b'} />
);

export const DiscordClipFeatureDescription = () => (
  <FeatureDescriptionModal id={'c6e74bd2-f229-4039-bced-690f16e8b204'} />
);

export const DiscordIntegrationClipEnabledFeatureDescription = () => (
  <FeatureDescriptionModal id={'43697eda-d211-427b-9ba5-6deb2743938d'} />
);
export const TokenFeatureDescription = () => (
  <FeatureDescriptionModal id={'9b0d8369-2237-49bc-aa9b-cc3dbb46cc9c'} />
);
export const WelcomeReferralDescription = () => (
  <FeatureDescriptionModal
    text={'BRO plan subscription'}
    id={'d8d3a402-3b67-4fa0-ac7d-e7586954ee53'}
  />
);
export const CSVFeatureDescription = () => (
  <FeatureDescriptionModal id={'a314da9c-46bb-4b60-9480-0e95a64e5f47'} />
);

export const IFTTTIntegrationFeatureDescription = () => (
  <FeatureDescriptionModal id={'306f1752-c1e8-40c7-97be-1ca3c2e5a777'} />
);
export const VoicemodIntegrationFeatureDescription = () => (
  <FeatureDescriptionModal id={'f1d1f587-5446-4a83-8fb5-47015c7daf9a'} />
);
export const IFTTTIntegrationEventNameFeatureDescription = () => (
  <FeatureDescriptionModal id={'261db77d-bb4b-4c78-b628-db7f2b3b279b'} />
);
export const IFTTTIntegrationKeyFeatureDescription = () => (
  <FeatureDescriptionModal id={'3da9f66c-d4e1-4774-9c28-3716b4b10ec1'} />
);

export const PulsoidLumiaFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'f791043f-bde9-436b-b45c-25f78e5ab0cf'}
    component={component}
  />
);
export const PulsoidStreamDeckFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'c8ddc132-2c9c-43f5-8732-8989df6b5343'}
    component={component}
  />
);
export const PulsoidPipelineFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'99835bb1-50fd-4fc4-b3f0-8d78e0c03cef'}
    component={component}
  />
);
// export const PulsoidVoicemodFeatureDescription = ({component}) => (
//   <FeatureDescriptionModal
//     id={'f1d1f587-5446-4a83-8fb5-47015c7daf9a'}
//     component={component}
//   />
// );
export const PulsoidStromnoFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'3b20544b-6869-4771-8425-1351ecaa33c3'}
    component={component}
  />
);
export const PulsoidLivFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'36aa85b6-5355-48eb-b48f-9969d7c389b2'}
    component={component}
  />
);
export const PulsoidWindowsAppFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'2f5cfc95-d862-4fef-bc7a-11b371bc2ae9  '}
    component={component}
  />
);
export const PulsoidVtsHeartRateFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'dbfc4cae-b663-44f3-9e1a-a710e49c0dea'}
    component={component}
  />
);
export const PulsoidStreamDeckIntegrationCardFeatureDescription = ({
  component,
}) => (
  <FeatureDescriptionModal
    id={'c8ddc132-2c9c-43f5-8732-8989df6b5343'}
    component={component}
  />
);

export const PulsoidBeatSaberModIntegrationCardFeatureDescription = ({
  component,
}) => (
  <FeatureDescriptionModal
    id={'40dcc519-e299-4c2f-9853-6ab0d18bf26d'}
    component={component}
  />
);

export const PulsoidAutomatedClipsCardFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'4e6013ab-059c-4718-ad64-b10cce78ed82'}
    component={component}
  />
);

export const PulsoidReportsCardFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'ad2e2cef-9160-41b7-a7f2-7b53315f63d2'}
    component={component}
  />
);

export const PulsoidAitumCardFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'84d438cb-6a77-4da4-9321-1b346f0ed352'}
    component={component}
  />
);

export const PulsoiStreamerBotCardFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'d8f61eda-5a4d-4e43-95d5-854741801311'}
    component={component}
  />
);

export const MagicChatboxFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'5eee3094-ef1c-4dc3-9c44-206eefd1cf07'}
    component={component}
  />
);

export const OyasumiVRFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'4ccbe871-46ae-4de5-9a80-b116d6c8741c'}
    component={component}
  />
);

export const AiLiciaVRFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'7ec440fe-54d1-4f2c-ba17-7dc69798501b'}
    component={component}
  />
);

export const OverwolfFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'c8f8ae59-9b2a-4a9f-8ee2-88d82849d609'}
    component={component}
  />
);

export const TwitchIntegratedThrowingSystemFeatureDescription = ({
  component,
}) => (
  <FeatureDescriptionModal
    id={'0879fecc-27a6-4990-9a36-e9d221c85867'}
    component={component}
  />
);

export const VRCOSCFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'53228b72-3f44-4847-b8a2-9808b9c3acb6'}
    component={component}
  />
);

export const RacelabFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'4a3d9857-31df-494c-a2c5-6492364cf188'}
    component={component}
  />
);

export const SAMMIFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'758d021f-f44d-476c-8c94-9cf45fbabbf6'}
    component={component}
  />
);

export const CrowdControlFeatureDescription = ({component}) => (
  <FeatureDescriptionModal
    id={'5263222f-2b69-4d8e-8c8c-e08eccb539d2'}
    component={component}
  />
);
